/**
 * Build API payload from filters and pagination.
 * @param {Object} filters - raw filter state
 * @param {number} page
 * @param {number} limit
 * @param {{ refresh?: boolean }} [meta] - if refresh, appends _refresh so Redis cache key differs (use after mutations).
 * @returns {Object} payload for getFilteredUsersAdmin
 */
export function buildFilterPayload(filters, page, limit, meta = {}) {
  const { profileCompletion, contactMissing, ...rest } = filters;
  const payload = {
    ...rest,
    occupation: filters.occupation ? [Number(filters.occupation)] : null,
    education: filters.education ? [Number(filters.education)] : null,
    marital: filters.marital ? [Number(filters.marital)] : null,
    religion: filters.religion ? [Number(filters.religion)] : null,
    country: filters.country ? [filters.country] : null,
    minHeight: filters.minHeight ? Number(filters.minHeight) : null,
    maxHeight: filters.maxHeight ? Number(filters.maxHeight) : null,
    minAge: filters.minAge ? Number(filters.minAge) : null,
    maxAge: filters.maxAge ? Number(filters.maxAge) : null,
    is_web:
      filters.is_web === "web" ? 1 : filters.is_web === "mobile" ? 0 : null,
    userId: filters.userId ? String(filters.userId).trim() || null : null,
    name: filters.name ? String(filters.name).trim() || null : null,
    email: filters.email ? String(filters.email).trim() || null : null,
    contactNo:
      contactMissing === "yes"
        ? null
        : filters.contactNo
          ? String(filters.contactNo).trim() || null
          : null,
    contact_missing: contactMissing === "yes" ? "yes" : null,
    contact_has: contactMissing === "has" ? "yes" : null,
    gender: filters.gender ? String(filters.gender).trim() || null : null,
    created_date_start: filters.created_date_start || null,
    created_date_end: filters.created_date_end || null,
    premium:
      filters.premium === "yes" ? 1 : filters.premium === "no" ? 0 : null,
    emailType:
      filters.emailType === "naseebimail" || filters.emailType === "other"
        ? filters.emailType
        : null,
    profile_gt_70: profileCompletion === "gt70" ? "yes" : null,
    profile_lt_70: profileCompletion === "lt70" ? "yes" : null,
    profile_eq_0: profileCompletion === "pct0" ? "yes" : null,
    profile_1_25: profileCompletion === "pct1_25" ? "yes" : null,
    profile_26_50: profileCompletion === "pct26_50" ? "yes" : null,
    page,
    limit,
  };
  if (meta.refresh) {
    payload._refresh = Date.now();
  }
  return payload;
}
